import { linkWrapper } from "../../../site/utils/links"
import { styleguideImgPlaceholder } from "../utils/helpers"
import { styleguidePlaceholderShape, styleguidePlaceholderText } from "./global"

export const fakeTitle = 'Leo eget bibendum sodales, augue velit cursus nunc leo eget'
export const fakeTitleShort = 'Etiam rhoncus maecenas tempus'
export const fakeIntro = 'Quis gravida magna mi a libero. Fusce vulputate eleifend sapien. Vestibulum purus quam, scelerisque ut, mollis sed, nonummy id, metus. Nullam accumsan lorem in dui. Leo eget bibendum sodales, augue velit cursus nunc.'
export const fakeIntroShort = 'Quis gravida magna mi a libero. Fusce vulputate eleifend sapien. Vestibulum purus quam.'
export const fakeIntroShortAlt = 'Scelerisque ut, mollis sed, nonummy id, metus. Nullam accumsan lorem in dui. Leo eget bibendum sodales, augue velit cursus nunc';
export const fakeIntroWYSIWYG = 'Quis gravida magna mi a libero. <a href="">Fusce vulputate</a> eleifend sapien. Vestibulum purus quam, scelerisque ut, mollis sed, nonummy id, metus. Nullam accumsan lorem in dui. Leo eget bibendum sodales, augue velit cursus nunc.'
export const fakeCaption = 'A pharetra augue itae sapien'
export const fakeSource = 'By John Doe'
export const fakeLabel = 'Scelerisque ut quam'
export const fakeButtonLabel = 'Luctus vitae'
export const fakeButtonSecondaryLabel = 'Nullam accumsan'
export const fakePrimaryLink = linkWrapper({ title: 'Luctus vitae', url: '#' })
export const fakeSecondaryLink = linkWrapper({ title: 'Nullam accumsan lorem', url: 'http://google.com' })
export const fakeReadMoreLink = linkWrapper({ title: 'Read more', url: '#' })
export const fakeInview = { threshold: 0.1, triggerOnce: true }
export const fakeVimeoVideo = { url: 'https://vimeo.com/188633351', id: '188633351', type: 'vimeo' }
export const fakeYouTubeVideo = { url: 'https://youtu.be/eRUQPfVACs0', id: 'eRUQPfVACs0', type: 'youtube' }
export const fakeDownloadPrimaryLink = { fileUrl: '/', title: 'Luctus vitae' }
export const fakeDownloadSecondaryLink = { fileUrl: '/', title: 'Nullam accumsan lorem' }

export const imgPlaceholder = (width: number, height: number, radius: string = '0', bgColor: string = styleguidePlaceholderShape.bgColor) => {
  return styleguideImgPlaceholder({
    shape: { width: width, height: height, radius: radius, bgColor: bgColor },
    text: { ...styleguidePlaceholderText }
  })
}
